import GlobalStyles from '@assets/styles/global-styles';
import 'dayjs/locale/en';
import 'dayjs/locale/th';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';

import PendingElement from '@components/pending-element/PendingElement';
import * as dayjs from 'dayjs';
import * as buddhistEra from 'dayjs/plugin/buddhistEra';

dayjs.extend(customParseFormat);
dayjs.extend(buddhistEra as unknown as dayjs.PluginFunc<unknown>);
dayjs.locale('th');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Suspense fallback={<PendingElement />}>
    <GlobalStyles />
    <App />
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
